import type { ReactNode } from "react";
import styled from "styled-components";

import { Typography } from "./Typography";

/**
 * [共通パーツ]「Icon+テキスト」的なボタン
 */

type StyledButtonProps = {
  $outline?: boolean;
  $buttonType?: "primary" | "danger";
};

type ButtonProps = {
  text?: string;
  icon: ReactNode;
  outline?: boolean;
  buttonType?: "primary" | "danger";
  onButtonClick?: () => void;
};

const StyledButton = styled.div<StyledButtonProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.$buttonType === "danger"
      ? props.theme.colors.caution
      : props.theme.colors.brand};
  ${(props) =>
    props.$outline &&
    `
    border: 3px solid;
    border-color: ${
      props.$buttonType === "danger"
        ? props.theme.colors.caution
        : props.theme.colors.brand
    };
    border-radius: 6px;
    padding: 10px 15px;
  `}
`;

const IconWrapper = styled.div`
  margin-right: 6px;
`;

export function IconTextButton(props: ButtonProps) {
  const { icon, text, outline, buttonType, onButtonClick } = props;
  return (
    <StyledButton
      onClick={onButtonClick}
      $outline={outline}
      $buttonType={buttonType}
    >
      <IconWrapper>{icon}</IconWrapper>
      {text && (
        <Typography size={2} bold>
          {text}
        </Typography>
      )}
    </StyledButton>
  );
}
